/** Portuguese (Brazil) catalog. Move names & Pokémon species stay English. */
export default {
  'deposit.title': 'Depósito',
  'deposit.eyebrow': 'Centro Pokémon',
  'deposit.sub': 'Guarde itens e mova Pokémon entre a equipe e o Box.',
  'deposit.close': 'Fechar depósito',
  'deposit.items': 'Itens',
  'deposit.pokemon': 'Pokémon',
  'deposit.searchItem': 'Buscar item...',
  'deposit.itemCategory': 'Filtrar categoria de item',
  'deposit.allCategories': 'Todas as categorias',
  'deposit.balls': 'Pokébolas',
  'deposit.potions': 'Poções',
  'deposit.stones': 'Pedras',
  'deposit.loot': 'Loot',
  'deposit.backpack': 'Mochila',
  'deposit.storage': 'Depósito',
  'deposit.storeAll': 'Guardar tudo',
  'deposit.searchPokemon': 'Buscar Pokémon...',
  'deposit.filterShiny': 'Somente Shiny',
  'deposit.from': 'de',
  'deposit.to': 'até',
  'deposit.level': 'Nível',
  'deposit.team': 'Equipe',
  'deposit.box': 'Box',
  'deposit.pokemonHint': 'Mova Pokémon entre a equipe e o Box. Seu parceiro principal permanece equipado.',
  'deposit.open': 'Depósito',
  'deposit.openAria': 'Abrir o depósito do Centro Pokémon',
  'deposit.resultsOf': '{filtered} de {total} Pokémon no Box',
  'deposit.noTeam': 'Nenhum Pokémon equipado.',
  'deposit.pokemonCount': '{count} Pokémon',
  'deposit.itemCount': '{count} itens guardados',
  'deposit.mainPartner': 'O parceiro principal não pode ser depositado',
  'deposit.moveToBox': 'Mover para o Box',
  'deposit.moveToTeam': 'Mover para a equipe',
  'deposit.emptyBackpack': 'Nenhum item na mochila com esses filtros.',
  'deposit.emptyStorage': 'Nada no depósito com esses filtros.',
  'deposit.withdrawItem': 'Retirar item',
  'deposit.storeItem': 'Guardar item',
  'deposit.serverItemsDisabled': 'Com inventário no servidor, o depósito de itens fica desativado (use a mochila).',
  'deposit.category.BALL': 'Pokébola',
  'deposit.category.POTION': 'Poção',
  'deposit.category.STONE': 'Pedra',
  'deposit.category.LOOT': 'Loot',
  'nav.main': 'Navegação principal',
  'nav.city': 'Cidade',
  'nav.hunt': 'Caçada',
  'nav.captures': 'Capturas',
  'nav.automation': 'Automação',
  'nav.inventory': 'Inventário',
  'nav.pokedex': 'Pokédex',
  'nav.market': 'Mercado',
  'nav.emeraldStore': 'Loja de Esmeraldas',
  'nav.gamePass': 'Game Pass',
  'nav.dailyGift': 'Daily Gift',
  'nav.specialization': 'Especialização',
  'nav.myPokemon': 'Meus Pokémon',
  'nav.collection': 'Coleção',
  'nav.map': 'Mapa',
  'nav.altar': 'Altar',
  'nav.breeding': 'Breeding',
  'nav.atlas': 'Atlas de Hunt',
  'nav.systems': 'Sistemas',
  'nav.compare': 'Comparar Pokémon',
  'compare.eyebrow': 'Laboratório de batalha',
  'compare.title': 'Comparar Pokémon',
  'compare.sub': 'Compare espécies simuladas ou seus Pokémon, projetando level e evolução sem alterar a coleção.',
  'compare.close': 'Fechar comparação',
  'compare.left': 'Pokémon 1',
  'compare.right': 'Pokémon 2',
  'compare.swap': 'Trocar os Pokémon',
  'compare.modeLabel': 'Fonte do comparativo',
  'compare.modeSpecies': 'Simular espécie',
  'compare.modeOwned': 'Meus Pokémon',
  'compare.search': 'Buscar Pokémon...',
  'compare.searchOwned': 'Buscar nos seus Pokémon...',
  'compare.noOwned': 'Você ainda não possui Pokémon para comparar.',
  'compare.pick': 'Busque um Pokémon para começar.',
  'compare.rarity': 'Raridade',
  'compare.quality': 'Qualidade (IV)',
  'compare.results': 'Comparativo',
  'compare.needBoth': 'Escolha os dois Pokémon para ver o comparativo.',
  'compare.power': 'Power',
  'compare.tie': 'Empate',
  'compare.powerLead': '{percent}% mais Power',
  'compare.wins': '{name} vence',
  'compare.ownedBadge': 'Seu Pokémon',
  'compare.originalLevel': 'Level atual',
  'compare.simulatedLevel': 'Level simulado',
  'compare.evolution': 'Evolução simulada',
  'compare.evolutionRequirement': 'Nv. {level}',
  'compare.shiny': 'Shiny',
  'compare.band.regular': 'Regular',
  'compare.band.promissor': 'Promissor',
  'compare.band.elite': 'Elite',
  'compare.band.perfeito': 'Perfeito',
  'compare.note': 'No modo de espécie, a simulação usa o multiplicador nominal da raridade e IVs distribuídos igualmente. No modo Meus Pokémon, os dados reais são usados apenas na prévia; nada aqui altera sua coleção.',
  'altar.eyebrow': 'Caminho garantido',
  'altar.title': 'Altar Shiny',
  'altar.intro': 'Gaste Shiny Cards genéricas para invocar uma batalha shiny garantida de uma espécie que você já viu.',
  'altar.steps': '1) Junte 50 cartas · 2) escolha uma espécie já vista · 3) invoque uma janela de encontros shiny garantidos.',
  'altar.cards': 'Shiny Cards',
  'altar.cardsOwned': '{count} cartas',
  'altar.cost': 'Custo: {cost}',
  'altar.pickSpecies': 'Escolha uma espécie',
  'altar.search': 'Buscar espécie...',
  'altar.invoke': 'Invocar shiny',
  'altar.needCards': 'Shiny Cards insuficientes.',
  'altar.needSpecies': 'Selecione uma espécie já vista.',
  'altar.invoked': 'Shiny de {name} invocado!',
  'altar.close': 'Fechar altar',
  'shiny.wildAppeared': '✦ Shiny {name} apareceu!',
  'shiny.captured': '✦ Shiny {name} capturado!',
  'shiny.cardDrop': '+{count} Shiny Card(s)',
  'shiny.guaranteed': 'Encontro shiny garantido',
  'breeding.eyebrow': 'Centro de Breeding',
  'breeding.title': 'Breeding',
  'breeding.intro': 'Dois pais viram um ovo — herança de IV, quality que sobe geração a geração, e a caça pela linhagem perfeita.',
  'breeding.pair': 'Par reprodutor',
  'breeding.slot': 'Slot {n}',
  'breeding.pickFromBox': 'Selecione no box',
  'breeding.clearSlot': 'Remover do slot',
  'breeding.parentsConsumed': 'Os 2 pais são CONSUMIDOS ao criar o ovo. Quality do filho = melhor pai + Δ.',
  'breeding.analysis': 'Análise de breeding',
  'breeding.mysteryChild': 'Filho misterioso',
  'breeding.emptyAnalysis': 'Escolha 2 pais no box para revelar a análise de compatibilidade e o range de quality.',
  'breeding.step1Title': 'Escolha 2 pais',
  'breeding.step1Text': 'Mesma espécie, direto do seu box',
  'breeding.step2Title': 'Pague o custo',
  'breeding.step2Text': 'Moedas, stones do elemento e feromônios',
  'breeding.step3Title': 'Choque na caça',
  'breeding.step3Text': 'Derrotas em hunt incubam o ovo',
  'breeding.needPair': 'Escolha 2 pais',
  'breeding.needPairToast': 'Selecione dois Pokémon da mesma espécie.',
  'breeding.incompatible': 'Par incompatível',
  'breeding.incompatibleHint': 'Os dois pais precisam ser da mesma espécie.',
  'breeding.compat': 'Compatibilidade',
  'breeding.ivInherit': 'Herança de IV',
  'breeding.qualityProjected': 'Quality projetada',
  'breeding.bestParent': 'Melhor pai: Q {q}',
  'breeding.cap': 'teto {cap}',
  'breeding.deltaChances': 'Chances de Δ (soma no melhor pai)',
  'breeding.ivCopyNote': 'IV copia o pai de maior Quality',
  'breeding.ivCopyBonus': '·+15%',
  'breeding.modePheromones': 'Feromônios',
  'breeding.modePheromonesHint': 'Δ cheio (+0.15 a +0.30)',
  'breeding.modeFree': 'Grátis',
  'breeding.modeFreeHint': 'Δ ~20× menor · ~20% menos de custo',
  'breeding.hatchInfo': 'Choca com até {count} derrotas em hunts',
  'breeding.doubleStones': 'Dobrar stones',
  'breeding.doubleStonesHint': '+15% herança · 5% de +1 no IV',
  'breeding.youHave': 'você tem {count}',
  'breeding.costLacking': 'Custo insuficiente',
  'breeding.createEgg': 'Criar ovo',
  'breeding.eggCreated': 'Ovo criado e colocado na incubadora!',
  'breeding.incubator': 'Incubadora',
  'breeding.incubatorFull': 'Incubadora cheia',
  'breeding.incubatorFullToast': 'Incubadora cheia (2 slots).',
  'breeding.slotFree': 'Slot livre',
  'breeding.noEggs': 'Nenhum ovo incubando.',
  'breeding.eggProgress': '{current} / {needed} derrotas',
  'breeding.eggReady': 'Pronto para chocar!',
  'breeding.hatched': '{name} chocou!',
  'breeding.activeBonuses': 'Bônus ativos',
  'breeding.bonusPheromonesText': '+0.15 a +0.30 de quality no filho',
  'breeding.bonusFreeText': 'Δ ~20× menor · custo ~20% menor',
  'breeding.bonusDouble': 'Stones em dobro',
  'breeding.bonusDoubleText': '+15% herança · 5% de +1 no IV',
  'breeding.box': 'Seus Pokémon (box)',
  'breeding.searchPlaceholder': 'Buscar por nome...',
  'breeding.sortIv': 'Maior IV',
  'breeding.sortQuality': 'Maior Q',
  'breeding.sortLevel': 'Maior Nv.',
  'breeding.sortName': 'Nome A–Z',
  'breeding.emptyBox': 'Nenhum Pokémon disponível no box.',
  'breeding.close': 'Fechar breeding',
  'breeding.notEnoughCoins': 'Ouro insuficiente.',
  'breeding.notEnoughStones': 'Pedras insuficientes.',
  'breeding.notEnoughPheromones': 'Feromônios insuficientes.',
  'atlas.eyebrow': 'Caçadas',
  'atlas.title': 'Atlas de Hunt',
  'atlas.intro': 'Escolha tipo, faixa de nível e a espécie específica que deseja caçar.',
  'atlas.pickType': 'Tipo',
  'atlas.pickLevel': 'Nível',
  'atlas.pickSpecies': 'Espécie',
  'atlas.search': 'Buscar espécie...',
  'atlas.difficulty': 'Dificuldade',
  'atlas.seen': 'Vista',
  'atlas.caught': 'Capturada',
  'atlas.notCaught': 'Não capturada',
  'atlas.speciesCount': '{count} espécies',
  'atlas.levelLabel': 'Nível da hunt',
  'atlas.unlockRequirement': 'Requisito para desbloquear',
  'atlas.unlockHint': 'Continue evoluindo seu Treinador para liberar esta hunt.',
  'atlas.unseen': '???',
  'atlas.startHunt': 'Caçar {name} · Nv.{level}',
  'atlas.startFailed': 'Não foi possível iniciar a hunt. Abra o console (F12) e tente de novo.',
  'atlas.needPartner': 'Equipe um Pokémon parceiro antes de caçar.',
  'atlas.bossTag': 'Boss',
  'atlas.zoneTag': 'Zona',
  'atlas.zoneLevelLabel': 'Tier da zona',
  'atlas.species': 'Pool',
  'atlas.pickZone': 'Zona',
  'atlas.zoneTitle': 'Zona {type} · Nv.{level}',
  'atlas.zoneIntro': 'Packs mono-espécie nos cantos do mapa. Um mini-boss pode invocar reforços — use skill em área.',
  'atlas.zoneIntroShort': 'No endgame você enfrenta biomas inteiros, com regras, pools e lendários próprios.',
  'atlas.zoneAoeHint': 'Recomendado: TM / skill em área no seu Pokémon.',
  'atlas.zoneAoeWarn': 'Zona densa: equipe uma skill em área (TM) para limpar os packs.',
  'atlas.startZone': 'Entrar em {type} · {level}',
  'atlas.back': 'Voltar',
  'atlas.close': 'Fechar atlas',
  'atlas.empty': 'Nenhuma espécie nesta faixa.',
  'atlas.legacyMode': 'Modo legado tipo×faixa',
  'hunt.speciesFocus': 'Foco: {name}',
  'hunt.mapTransition': '{name} saiu das ruínas — a hunt avançou para o deserto.',
  'hunt.mapTransitionLog': '{name} atravessou a pirâmide e chegou ao deserto.',
  'hunt.zoneFocus': '{type} · {level}',
  'team.aoeSlot': 'Skill em área',
  'team.aoeLocked': 'Liberado no Nv.{level}',
  'team.aoeEmpty': 'Nenhuma TM equipada',
  'team.equipTm': 'Equipar TM',
  'team.unequipAoe': 'Remover AoE',
  'team.tmOwned': '{count} TM(s)',
  'team.tmApplied': 'TM aplicada: {move}',
  'team.noTm': 'Você não tem TMs.',
  'boss.label': 'BOSS',
  'boss.adds': '+{count} adds',
  'battle.multiTargets': '{count} alvos',
  'zone.apex': 'Apex',
  'zone.threatTier': 'Ameaça {tier}',
  'zone.recommendedPower': 'Power recomendado',
  'zone.powerValue': 'Power recomendado: {power}',
  'zone.nextBoss': 'Próximo lendário',
  'zone.rewardBonus': 'Bônus de XP',
  'zone.bossProgress': 'Rastro do lendário',
  'zone.effectsSummary': '+{xp}% XP · +{loot}% drops · +{damage}% dano inimigo',
  'zone.legendaryRotation': 'Rotação lendária',
  'zone.legendaryGuideTitle': 'Como o lendário aparece',
  'zone.legendaryGuide': 'Derrote {count} Pokémon desta zona para completar o Rastro Lendário. O próximo encontro especial será {name}; ao vencê-lo ou capturá-lo, o rastro reinicia e a rotação avança.',
  'zone.legendaryBoss': 'LENDÁRIO',
  'zone.mythicalBoss': 'MÍTICO',
  'zone.hourlyFeatured': 'Destaque da hora',
  'zone.hourlyFocusTitle': 'Encontro especial (GMT-3)',
  'zone.hourlyFocusGuide': 'Chance rara (~1 em {n} abates) de surgir o {kind} em destaque: {name}. Sem garantia. Uma bola por KO — Master/Apex recomendadas.',
  'zone.rotationCountdown': 'Troca em {time}',
  'zone.specialOdds': '~1/{n} abates',
  'zone.specialPool': 'Pool da hora',
  'zone.noSpecial': '—',
  'zone.noSpecialTitle': 'Sem rotação especial',
  'zone.noSpecialHint': 'Esta zona tem packs e mini-bosses do bioma, sem lendário/mítico horário.',
  'zone.captureHint': 'Ultra ~1% no endgame. Master Ball garante; Apex Ball ~25% nos especiais.',
  'zone.specialAppearedLog': '{name} surgiu em {zone} (destaque da hora)!',
  'zone.specialAppearedToast': '{name} surgiu! Destaque da hora.',
  'zone.enter': 'Entrar na zona',
  'zone.requirement.trainerLevel': 'Treinador Nv.{value}',
  'zone.requirement.mastery': 'Maestria {value}',
  'zone.requirement.prestige': 'Prestígio {value}',
  'zone.bossReadyLog': 'O rastro em {zone} está completo. O lendário apareceu.',
  'zone.bossReadyToast': 'Chefe lendário liberado!',
  'zone.bossDefeated': '{name} foi vencido em {zone}.',
  'zone.bossDefeatedToast': '{name} derrotado!',
  'zones.supreme-threshold.title': 'Fronteira Suprema',
  'zones.supreme-threshold.description': 'Campeões de vários biomas testam a base do seu time antes das ameaças maiores.',
  'zones.ashen-spire.title': 'Espira das Cinzas',
  'zones.ashen-spire.description': 'Calor extremo fortalece atacantes e torna cada investida mais perigosa.',
  'zones.obsidian-court.title': 'Corte de Obsidiana',
  'zones.obsidian-court.description': 'Uma fortaleza de aço e pedra, feita para lutas longas contra defesas pesadas.',
  'zones.eclipse-rift.title': 'Fenda do Eclipse',
  'zones.eclipse-rift.description': 'Sombras e energia psíquica: pool de lendários com destaque a cada hora (GMT-3).',
  'zones.final-horizon.title': 'Horizonte Final',
  'zones.final-horizon.description': 'O desafio máximo: pool de míticos com destaque horário e a captura mais exigente do endgame.',

  'items.apexball.name': 'Apex Ball',
  'items.apexball.desc': '~25% de captura nos especiais de zona (Threat 3/4).',
  'shop.emeraldBalls': 'Bolas premium',
  'shop.vipMasterGift': 'Assinar VIP concede 1 Master Ball.',
  'profile.trainer': 'Treinador',
  'profile.level': 'Nível',
  'profile.title': 'Perfil',
  'profile.sub': 'Identidade, progresso e atalhos do treinador.',
  'profile.general': 'Informações gerais',
  'profile.progression': 'Progressão',
  'profile.captureLog': 'Log de capturas',
  'profile.customizeOutfit': 'Personalizar outfit',
  'profile.saveOutfit': 'Salvar outfit',
  'profile.outfitEyebrow': 'Aparência',
  'profile.outfitTitle': 'Personalizar outfit',
  'profile.openPrestige': 'Treinador e Prestígio',
  'profile.since': 'desde o início',
  'profile.coins': 'Ouro',
  'profile.defeated': 'Derrotas',
  'profile.captured': 'Capturas',
  'profile.pokedex': 'Pokédex',
  'profile.prestige': 'Prestígio',
  'profile.peakLevel': 'Nível máximo',
  'profile.talents': 'Pontos de especialização',
  'profile.outfitSaved': 'Outfit atualizado!',
  'profile.xpLine': '{current} / {max} XP',
  'profile.xpReady': 'Pronto para Prestígio',
  'profile.pokedexProgress': '{owned}/{total}',
  'profile.footer': 'IdleMon — Perfil de {name}',

  'settings.open': 'Configurações',
  'settings.title': 'Configurações',
  'settings.language': 'Idioma',
  'settings.language.en': 'English',
  'settings.language.pt-BR': 'Português (BR)',
  'settings.language.es': 'Español',
  'settings.close': 'Fechar configurações',

  'common.close': 'Fechar',
  'common.new': 'Novo',
  'confirm.eyebrow': 'Confirmação',
  'confirm.title': 'Confirmar ação',
  'common.you': 'Você',
  'common.lv': 'Nv.',
  'common.coins': 'IdleCoin',
  'common.active': 'ATIVO',
  'common.buy': 'Comprar',
  'common.sell': 'Vender',
  'common.selectAll': 'Selecionar tudo',
  'common.evolve': 'Evoluir',
  'common.status': 'Status',
  'common.power': 'Poder',
  'common.emptySlot': 'Espaço vazio',
  'common.learned': 'APRENDIDO',
  'common.area': 'Área',

  'battle.searching': 'PROCURANDO POKÉMON',
  'battle.searchingNext': 'PROCURANDO O PRÓXIMO',
  'battle.paused': 'JORNADA PAUSADA',
  'battle.walking': 'Andando automaticamente',
  'battle.seekingTarget': '{name} está procurando um alvo',
  'battle.yourPokemon': '{name} · Seu Pokémon',
  'battle.sound': 'Ativar/desativar som',
  'battle.routeLabel': 'ROTA {type} · NÍVEL {min}–{max}',
  'battle.defeatedTitle': '{name} derrotado!',
  'battle.cannotAttack': '{name} não consegue atacar!',
  'battle.combat': 'Combate',
  'battle.expTrainer': 'EXP Treinador',
  'battle.expPokemon': 'EXP Pokémon',
  'battle.total': 'total',
  'battle.levelUp': '{name} subiu para o Nv. {level}!',
  'levelup.eyebrow': 'LEVEL UP!',
  'levelup.text': 'Você subiu de nível!',
  'battle.drops': 'Itens',

  'team.heading': 'MEU TIME',
  'team.equipped': 'Pokémon equipados',
  'team.aria': 'Meu time',
  'team.manageTitle': 'Meus Pokémon',
  'team.manageEyebrow': 'Time ativo',
  'team.manageHint': 'Gerencie status, evolução e golpes dos seus seis Pokémon equipados.',
  'team.close': 'Fechar Meus Pokémon',
  'team.noPartner': 'Escolha seu primeiro parceiro antes de gerenciar o time.',
  'team.movesDiscarded': 'Alterações de golpes não aplicadas foram descartadas.',
  'team.movesApplied': 'Golpes de {name} aplicados!',
  'team.evolveTo': 'Evoluir para {name}',
  'team.noMoves': 'Nenhum golpe disponível neste nível.',
  'team.applyMoves': 'Aplicar golpes',

  'hunt.last': 'Última caçada',
  'hunt.analyzer': 'Hunt Analyzer',
  'hunt.sub': 'Taxas da sessão, loot e balanço da última caçada.',
  'hunt.close': 'Fechar Hunt Analyzer',
  'hunt.lastRoute': 'ÚLTIMA ROTA CONCLUÍDA',
  'hunt.none': 'Nenhuma caçada registrada',
  'hunt.completeHint': 'Complete uma jornada para ver o resumo.',
  'hunt.time': 'Tempo de caçada',
  'hunt.defeated': 'Derrotados',
  'hunt.captured': 'Capturados',
  'hunt.xp': 'EXP ganha',
  'hunt.currentSession': 'SESSÃO ATUAL',
  'hunt.loot': 'Loot',
  'hunt.supply': 'Supply',
  'hunt.itemsCount': '{count} itens',
  'hunt.supplyDetail': '{balls} balls · {potions} poções',
  'hunt.balance': 'Saldo (Loot + Capturas − Supply)',
  'hunt.sessionDrops': 'Drops da sessão',
  'hunt.noDrops': 'Nenhum item dropado ainda.',
  'hunt.rateHint': 'Taxas com base nos últimos 10 minutos de caçada',
  'hunt.grossRate': 'Receita bruta / hora',
  'hunt.supplyRate': 'Consumo / hora',
  'hunt.netRate': 'Saldo líquido / hora',
  'hunt.economyHealthy': 'Hunt sustentável nesta amostra',
  'hunt.economyWarning': 'Consumo maior que a receita — ajuste rota/equipamento',

  'capture.title': 'Registro de Capturas',
  'capture.eyebrow': 'Registro de capturas · últimas 100',
  'capture.sub': 'Capturas recentes com raridade, IV e destaque shiny.',
  'capture.close': 'Fechar registro de capturas',
  'capture.total': 'Total:',
  'capture.normals': 'Normais:',
  'capture.filterAll': 'Todos',
  'capture.filterNormal': 'Normal',
  'capture.foot': '✨ Capturas Shiny ficam destacadas. O histórico atualiza automaticamente.',
  'capture.empty': 'Nenhuma captura encontrada para este filtro.',
  'capture.ivUnavailable': 'IVs detalhados indisponíveis para esta captura.',
  'capture.panelTitle': 'Captura',
  'capture.ready': '{count} prontos',
  'capture.throw': 'Lançar',
  'capture.caught': 'Capturado',
  'capture.escaped': 'Escapou',
  'capture.chance': '{pct}%',
  'capture.noBall': 'Sem bolas',
  'capture.autoCaught': 'Capturado!',
  'capture.autoEscaped': 'Escapou',
  'capture.capReached': 'Limite diário de capturas atingido',
  'capture.shinyCapReached': 'Limite diário de capturas shiny atingido',
  'capture.highIvCapReached': 'Limite diário de capturas de IV alto atingido',
  'capture.autoChance': '{pct}% de chance',
  'capture.vipSkip': 'Ignorado (filtro VIP)',

  'auto.eyebrow': 'Automação',
  'auto.title': 'Auto-Helper',
  'auto.sub': 'Defina como o parceiro usa os itens da sua mochila.',
  'auto.close': 'Fechar automação',
  'auto.capture': 'Captura automática',
  'auto.captureHint': 'Tentar capturar após vencer',
  'auto.captureNormalHint': 'Capturar Pokémon normais após vencer',
  'auto.captureVip': 'Recurso VIP — assine para capturar automaticamente após vencer.',
  'auto.ball': 'Poké Ball usada',
  'auto.ballNone': 'Nenhuma Poké Ball no inventário.',
  'auto.potion': 'Poção automática',
  'auto.potionHint': 'Curar automaticamente com HP baixo',
  'auto.potionWhen': 'Usar poção quando HP ≤',
  'auto.potionUsed': 'Poção usada',
  'auto.revive': 'Reviver automaticamente',
  'auto.reviveHint': 'Usar Revive quando seu parceiro cair',
  'auto.reviveUsed': 'Revive usado',
  'auto.reviveStock': '{count} Revive(s) disponível(is)',
  'auto.reviveNone': 'Nenhum Revive no inventário.',
  'auto.shiny': 'Capturar Shiny automaticamente',
  'auto.shinyHint': 'Usar uma bola exclusiva para Pokémon Shiny',
  'auto.shinyBall': 'Poké Ball para Shiny',
  'auto.vip': 'Captura seletiva',
  'auto.vipHint': 'Capturar apenas os Pokémon que você escolher nesta rota.',
  'auto.vipNote': '✦ Disponível com assinatura VIP',
  'auto.speciesOnRoute': '{count} espécies nesta rota',
  'auto.pickAny': 'Selecione qualquer combinação',
  'auto.emptyPool': 'Nenhum encontro configurado nesta rota.',

  'inv.eyebrow': 'Mochila do treinador',
  'inv.title': 'Inventário',
  'inv.sub': 'Balls, poções, drops e suprimentos.',
  'inv.close': 'Fechar inventário',
  'inv.items': 'Itens:',
  'inv.drops': 'Drops:',
  'inv.dropsValue': '{value} IdleCoin',
  'inv.foot': 'Drops podem ser vendidos na loja da cidade. Poções e balls também aparecem em Automação.',
  'inv.empty': 'Mochila vazia.',
  'inv.section.balls': 'Poké Balls',
  'inv.section.potions': 'Poções',
  'inv.section.stones': 'Pedras de evolução',
  'inv.section.drops': 'Drops',

  'dex.eyebrow': 'Espécies com sprites Myst',
  'dex.title': 'Pokédex',
  'dex.sub': 'Navegue espécies, status, evoluções e estimativa de venda.',
  'dex.close': 'Fechar Pokédex',
  'dex.search': 'Buscar nome ou #...',
  'dex.allTypes': 'Todos os tipos',
  'dex.ownedOnly': 'Somente capturados',
  'dex.seen': 'Vistos:',
  'dex.caught': 'Capturados:',
  'dex.emptyDetail': 'Selecione um Pokémon para ver status, evoluções e preço de venda.',
  'dex.filterType': 'Filtrar por tipo',
  'dex.locations': 'Onde aparece',
  'dex.atlasFocus': 'Foco no Atlas',
  'dex.fishing': 'Pesca',
  'dex.noLocations': 'Não aparece nas rotas selvagens atuais (fora do pool de hunt).',
  'dex.capture': 'Captura',
  'dex.catchInfo': 'Dificuldade base da espécie: {label} · taxa base {rate} · nível e bola definem a chance real em combate.',
  'dex.baseStats': 'Stats base',
  'dex.stat.hp': 'HP',
  'dex.stat.atk': 'ATQ',
  'dex.stat.def': 'DEF',
  'dex.stat.spa': 'A.ESP',
  'dex.stat.spd': 'D.ESP',
  'dex.stat.spe': 'VEL',
  'dex.evoLine': 'Linha evolutiva',
  'dex.baseForm': 'base',
  'dex.sellSection': 'Venda',
  'dex.sellNote': 'Transferência estimada de um exemplar comum Nv.1/IV50: {price} IdleCoin. O valor sobe com nível, IV e qualidade.',
  'dex.notOwned': 'Você ainda não possui este Pokémon. Capture um para poder vender.',
  'dex.noneFound': 'Nenhum Pokémon encontrado.',
  'dex.legendary': 'LENDÁRIO',

  'col.eyebrow': 'Pokédex pessoal',
  'col.title': 'Sua coleção',
  'col.close': 'Fechar coleção',
  'col.hint': 'Raridade e IV na lista · clique para detalhes',
  'col.search': 'Buscar por nome...',
  'col.filterType': 'Filtrar por tipo',
  'col.filterRarity': 'Filtrar por raridade',
  'col.ivMode': 'Modo de filtro de IV',
  'col.ivMin': 'IV mín.',
  'col.ivMax': 'IV máx.',
  'col.ivValue': 'IV total de 0 a 186',
  'col.clear': 'Limpar filtros',
  'col.allTypes': 'Todos os tipos',
  'col.allRarities': 'Todas as raridades',
  'col.results': '{count} Pokémon',

  'city.safeZone': 'Zona segura · Multijogador',
  'city.walkHint': 'Use W A S D para andar · mapa original',
  'city.floor': 'Andar 7',
  'city.teleport': 'Atalho da cidade',
  'city.teleportHint': 'Ir para a loja',
  'city.teleportTitle': 'Destinos da cidade',
  'city.teleportAria': 'Teletransportar para a loja',
  'city.teleportMenuAria': 'Destinos de teleporte da cidade',
  'city.teleportDestinations': '{count} destinos disponíveis',
  'city.arrivedNpc': 'Você chegou até {name}.',
  'city.store': 'Loja',
  'city.storeAria': 'Ir para a loja',
  'city.healTeam': 'Curar time',
  'city.openShop': 'Abrir loja',
  'city.openTmShop': 'Ver drops de TMs',
  'city.fisherName': 'Finn',
  'city.startFishing': 'Começar a pescar',
  'city.mapAlt': 'Saffron City do mapa original do Poketibia',
  'city.roofsAlt': 'Telhados de Saffron City',
  'city.pcRoofAlt': 'Telhado do Pokémon Center',
  'city.shopRoofAlt': 'Telhado da loja',
  'city.trainerAlt': 'Seu treinador',
  'city.partnerAlt': 'Seu Pokémon principal',
  'city.routeMapAlt': 'Mapa original de rotas',
  'city.arrivedShop': 'Você chegou à loja.',
  'city.welcome': 'Bem-vindo a Saffron City, treinador!',
  'city.marketSoon': 'Mercado de trocas em breve.',
  'city.soundSoon': 'O som será adicionado com os efeitos de batalha.',

  'fish.eyebrow': 'Cais de Saffron',
  'fish.title': 'Pesca',
  'fish.sub': 'Escolha local, isca e vara, depois lance. Espécies aquáticas só saem daqui.',
  'fish.hint': 'Pokémon aquáticos só saem daqui. A vara limita o teto; ela não aumenta seu nível nem escolhe a faixa sozinha.',
  'fish.statusEyebrow': 'Status',
  'fish.spotEyebrow': 'Local',
  'fish.baitEyebrow': 'Isca',
  'fish.rodEyebrow': 'Vara',
  'fish.idle': 'Pronto para lançar.',
  'fish.casting': 'Linha na água…',
  'fish.start': 'Começar a pescar',
  'fish.stop': 'Parar de pescar',
  'fish.started': 'Pesca iniciada.',
  'fish.stopped': 'Pesca pausada.',
  'fish.needRod': 'Compre uma vara na loja.',
  'fish.busyHunt': 'Termine a caçada antes de pescar.',
  'fish.bandHint': 'Pesca Nv.{min}–{max} · faixa selecionada: Nv.{selected} · {rod}',
  'fish.rodRange': 'Até Nv.{max}',
  'fish.rodEffect': 'Alcance até Nv.{max} · não muda seu nível',
  'fish.caught': 'Capturou {name} Nv.{level}!',
  'fish.escaped': '{name} escapou.',
  'fish.noBall': 'Sem Pokébolas — pesca pausada.',
  'fish.noBaitStock': 'Isca esgotada — pesca pausada.',
  'fish.nibble': 'Uma fisgada… nada desta vez.',
  'fish.xpLabel': 'Pesca Nv.{level} · XP {xp}',
  'fish.spotLocked': 'Requer pesca Nv.{level}',
  'fish.spotReady': 'Aberto',
  'fish.noBait': 'Sem isca',
  'fish.baitNoneHint': 'Velocidade base de cast',
  'fish.spot.pier': 'Píer',
  'fish.spot.deepSea': 'Mar profundo',
  'fish.bait.common': 'Isca comum',
  'fish.bait.elite': 'Isca elite',
  'fish.mat.fins': 'Barbatanas',
  'fish.mat.water-pendant': 'Pingente d\'água',
  'fish.mat.pearl': 'Pérola',
  'fish.mat.dome-fossil': 'Fóssil Domo',
  'fish.mat.helix-fossil': 'Fóssil Hélix',
  'fish.mat.old-amber': 'Âmbar Velho',
  'systems.hubTitle': 'Sistemas da cidade',
  'systems.hubSub': 'Economia · retenção · premium · combate',
  'raid.title': 'World Raid',
  'raid.hubSub': 'Chefe mundial',
  'raid.hubNew': 'Novo chefe',
  'raid.hubHp': '{pct}% derrotado',
  'raid.hubDefeated': 'Derrotado — resgate!',
  'raid.hubExpired': 'Janela encerrada',
  'raid.hint': 'Caçe normalmente: cada derrota na hunt contribui dano ao boss. Não há botão de spam — o progresso vem da caçada.',
  'raid.yourContrib': 'Sua contribuição: {value}',
  'raid.damagePct': '{pct}% do HP já removido',
  'raid.statusActive': 'Ativo · termina em {time}',
  'raid.statusDefeated': 'Boss derrotado! Resgate sua recompensa.',
  'raid.statusExpired': 'Janela encerrada. Resgate pela sua contribuição.',
  'raid.statusClaimed': 'Recompensa já resgatada. Novo chefe no ar.',
  'raid.claim': 'Resgatar recompensa',
  'raid.claimed': 'Já resgatado',
  'raid.claimHintReady': 'Pronto para resgatar — loot proporcional à sua contribuição.',
  'raid.claimHintDone': 'Você já resgatou nesta raid.',
  'raid.claimHintNoDmg': 'Caçe wilds para contribuir dano antes de resgatar.',
  'raid.claimHintActive': 'O boss ainda está de pé. Continue caçando até o HP zerar (ou a janela acabar).',
  'raid.claimHintWait': 'Aguarde o fim da raid para resgatar.',
  'raid.claimOk': 'Loot: {loot}',
  'raid.timeHours': '{hours}h {mins}m',
  'raid.timeMins': '{mins}m',
  'raid.err.raid_still_active': 'O boss ainda está ativo — continue caçando.',
  'raid.err.already_claimed': 'Você já resgatou nesta raid.',
  'raid.err.no_contribution': 'Sem contribuição — caçe wilds primeiro.',
  'raid.err.invalid_raid': 'Raid inválida.',
  'raid.err.generic': 'Não foi possível resgatar.',
  'npc.shop': 'Loja',
  'npc.tmShop': 'Loja de TMs',
  'npc.nurse': 'Nurse Joy',
  'npc.blacksmith': 'Ferreiro',
  'npc.apothecary': 'Boticário',
  'npc.miner': 'Minerador',
  'npc.fisher': 'Pescador',
  'npc.professor': 'Professor',
  'npc.questBoard': 'Quadro de Missões',
  'npc.gymLeader': 'Líder de Ginásio',
  'npc.clanHerald': 'Casa do Clã',
  'npc.auctioneer': 'Leiloeiro',

  'chat.aria': 'Chat global',
  'chat.world': 'Mundo',
  'chat.trade': 'Troca',
  'chat.help': 'Ajuda',
  'chat.online': 'Online',
  'chat.placeholder': 'Falar em Mundo...',
  'chat.send': 'Enviar',
  'chat.placeholder.world': 'Falar em Mundo...',
  'chat.placeholder.trade': 'Falar em Troca...',
  'chat.placeholder.help': 'Pedir ajuda...',
  'chat.loading': 'Carregando mensagens...',
  'chat.empty': 'Ainda não há mensagens neste canal.',
  'chat.systemCapture': '{trainer} capturou {name} ({tag})!',
  'chat.error': 'Não foi possível atualizar o chat.',
  'chat.muted': 'Você está mutado e não pode enviar mensagens agora.',
  'chat.slowDown': 'Você está enviando mensagens rápido demais.',
  'chat.blockedLanguage': 'Sua mensagem contém linguagem que não é permitida no chat.',
  'chat.invalidAttachment': 'Este item ou Pokémon não pode ser vinculado.',
  'chat.attachmentLimit': 'Você pode vincular até {count} assets por mensagem.',
  'chat.alreadyLinked': 'Este asset já está vinculado.',
  'chat.linked': '{name} foi vinculado ao chat.',
  'chat.removeAttachment': 'Remover vínculo',
  'chat.shiftToLink': 'Shift + clique para vincular ao chat',
  'chat.quantity': 'Quantidade',
  'chat.moves': 'Golpes',
  'chat.equipped': 'Equipado',
  'chat.partner': 'Parceiro',
  'chat.verified': 'Custódia verificada',
  'chat.verifiedHint': 'Asset verificado no inventário do servidor no momento da mensagem.',
  'chat.localSnapshot': 'Fotografia do save local publicada por este jogador.',
  'chat.previewOnly': 'O envio está desativado na prévia visual.',
  'chat.previewWelcome': 'Bem-vindo ao chat do IdleMon!',
  'chat.previewTrade': 'Olhem este Pokémon que equipei.',
  'chat.previewHelp': 'Passe o mouse sobre o vínculo para ver os detalhes.',
  'admin.open': 'Admin',
  'inv.pokemon': 'Pokémon:',
  'inv.section.pokemon': 'POKÉMON · SHIFT + CLIQUE PARA VINCULAR',

  'map.eyebrow': 'Explore o mundo',
  'map.title': 'Mapa de rotas',
  'map.levelBand': 'FAIXA DE NÍVEL',
  'map.close': 'Fechar mapa',
  'map.youAreHere': 'VOCÊ ESTÁ AQUI',
  'map.region': 'REGIÃO',
  'map.bossesSoon': 'Em breve',
  'map.bossesTitle': 'Zonas AoE',
  'map.bossesZones': 'Endgame',
  'map.bossesHint': 'Arenas e Pokémon lendários do Myst aparecerão aqui. Por enquanto, explore as rotas por faixa de nível.',
  'map.bossesHintActive': 'Escolha o nível da zona e o tipo. Packs mono-espécie surgem nos cantos; mini-bosses invocam reforços.',
  'map.legendCity': 'Cidade',
  'map.legendRoute': 'Rota disponível',
  'map.legendPick': 'Selecione uma rota para viajar',
  'map.route': 'Rota {type} · {levels}',
  'map.speciesChance': '{count} espécies · chance por encontro',
  'map.preview': 'Prévia · {hint}',
  'map.lockBand': 'Faixa desbloqueia no Nv. {level}',
  'map.lockLevel': '{type} desbloqueia no Nv. {level}',
  'map.lockHint': '{type} só aparece a partir do Nv. {level}.',
  'map.travelLog': 'Você viajou para a rota do tipo {type}.',
  'map.arriving': 'Chegando ao território {type}...',
  'map.bosses': 'Zonas',
  'map.routes': 'Rotas',

  'dialog.pcEyebrow': 'Pokémon Center',
  'dialog.pcText': 'Bem-vindo ao Pokémon Center! Posso restaurar totalmente o seu time de graça.',
  'dialog.healAll': 'Curar todos os Pokémon',
  'dialog.healedLog': 'O time inteiro foi curado no Pokémon Center.',
  'dialog.healedToast': 'Seu time está totalmente recuperado!',
  'dialog.faintedLog': '{name} desmaiou e foi levado ao Pokémon Center. O time foi curado.',
  'dialog.faintedToast': 'Seu Pokémon foi levado ao Pokémon Center e está recuperado!',
  'dialog.shopTitle': 'Loja do Sam',
  'dialog.shopEyebrow': 'Loja da cidade',
  'dialog.shopSub': 'Compre suprimentos, venda drops e Pokémon sobrando.',
  'dialog.tmShopTitle': 'TMs do Sammy',
  'dialog.tmShopIntro': 'TMs não são vendidas. Todas as 18 podem cair em encounters regulares de zonas avançadas, com peso maior para o tipo da zona. Cada disco é consumido ao ensinar e só pode ser usado em um Pokémon Nv. 100 ou superior.',
  'dialog.tmDropOnly': 'As 18 TMs são obtidas exclusivamente em drops de encounters regulares das zonas avançadas.',
  'dialog.tmDropOnlyShort': 'Drop avançado',
  'dialog.dropOnlyItem': 'Este item só pode ser obtido como drop de uma zona avançada.',
  'dialog.tmEffect': 'Golpe em área de {type} · requer Pokémon Nv.{level}',
  'dialog.closeShop': 'Fechar loja',
  'dialog.qty': 'Quantidade',
  'dialog.ivFrom': 'de',
  'dialog.ivTo': 'até',
  'dialog.ivMin': 'IV mín. (0–186)',
  'dialog.ivMax': 'IV máx. (0–186)',
  'dialog.buy': 'Comprar',
  'dialog.sell': 'Vender',
  'dialog.sellTotal': 'Total ({count})',
  'dialog.pokemon': 'Pokémon',
  'dialog.noDrops': 'Nenhum drop para vender ainda.',
  'dialog.noPokemonFilter': 'Nenhum Pokémon corresponde aos filtros.',
  'dialog.pickItem': 'Selecione pelo menos um item.',
  'dialog.pickPokemon': 'Selecione pelo menos um Pokémon.',
  'dialog.bought': 'Comprou {qty}× {name}.',
  'dialog.soldDrops': 'Vendido por {total} IdleCoin!',
  'dialog.soldPokemon': 'Vendeu {count} Pokémon por {total} IdleCoin!',
  'dialog.noCoins': 'IdleCoin insuficiente.',
  'dialog.inStock': 'possui {qty}',
  'dialog.stockLine': '{qty}× em estoque · {total}',
  'dialog.onTeam': 'no time',
  'dialog.lockSale': 'Travar venda',
  'dialog.unlockSale': 'Destravar venda',

  'evo.eyebrow': 'Evolução disponível',
  'evo.title': 'Evoluir Pokémon',
  'evo.sub': 'Escolha como evoluir. IVs e raridade são sempre mantidos.',
  'evo.fromAlt': 'Forma atual',
  'evo.toAlt': 'Próxima evolução',
  'evo.warning': 'Em uma evolução normal, o Pokémon volta ao nível 1. IVs e raridade são mantidos.',
  'evo.normal': 'Evoluir e voltar ao nível 1',
  'evo.coins': 'Manter nível com IdleCoin',
  'evo.coinCost': '{cost} IdleCoin para manter o nível {level}',
  'evo.notEnoughCoins': 'IdleCoin insuficiente para esta evolução.',
  'evo.canEvolve': '{name} pode evoluir!',
  'evo.toast': '{from} evoluiu para {to}!',
  'common.yes': 'Sim',
  'common.no': 'Não',
  'mastery.leveled': '{name} alcançou Maestria {level}!',
  'capture.hpChance': '{hp}% de HP · {pct}% de chance',
  'battle.initiative': 'Iniciativa',
  'battle.captureWindow': 'Janela de captura',
  'progress.eyebrow': 'Progressão avançada',
  'progress.title': 'Treinador e Prestígio',
  'progress.sub': 'Bônus da conta, caminho de XP e reset de Prestígio.',
  'progress.perksEyebrow': 'Bônus da conta',
  'progress.prestige': 'Prestigiar treinador',
  'progress.prestigeShort': 'Prestígio {count}',
  'progress.ready': 'Pronto para Prestígio',
  'progress.xp': '{current} / {max} XP',
  'progress.offlineTraining': 'Treino offline',
  'progress.reserveVip': 'Reserva (VIP)',
  'progress.loot': 'Loot extra',
  'progress.capture': 'Bônus de captura',
  'progress.xpBonus': 'Bônus total de XP',
  'progress.offlineCap': 'Limite offline',
  'progress.mastery': 'Maestria liberada',
  'progress.note': 'O Prestígio reinicia o nível atual, mas mantém rotas e Maestria. Cada Prestígio dá 2% de XP, 1 hora offline, 1 ponto de Especialização e 1 redefinição grátis.',
  'progress.maxPrestige': 'Prestígio máximo alcançado',
  'progress.requires300': 'Requer treinador nível 300',
  'progress.confirm': 'Prestigiar agora? O treinador volta ao nível 1, mas mantém as rotas e a Maestria liberadas.',
  'progress.completed': 'Prestígio de treinador {count} alcançado!',
  'progress.openSpecialization': 'Abrir Especialização',
  'specialization.close': 'Fechar Especialização',
  'specialization.eyebrow': 'Streak Points',
  'specialization.title': 'Streak Points',
  'specialization.intro': 'Invista pontos de talento e acompanhe abates. Marcos de nível e Prestígio concedem pontos; a Veterania sobe a cada 1.000 derrotas.',
  'specialization.statsEyebrow': 'Visão geral',
  'specialization.investEyebrow': 'Investir',
  'specialization.available': 'pontos disponíveis',
  'specialization.allocated': 'pontos distribuídos',
  'specialization.prestigeCount': 'nível de Prestígio',
  'specialization.stat.totalKills': 'Abates totais',
  'specialization.stat.available': 'Pontos disponíveis',
  'specialization.stat.used': 'Pontos usados',
  'specialization.stat.nextPoint': 'Próximo marco em',
'specialization.streakNote': '1 Streak Point a cada 1.000 abates · pontos investíveis vêm dos marcos de derrotas',
  'specialization.streak.exp': 'EXP',
  'specialization.streak.loot': 'LOOT',
  'specialization.streak.catch': 'CATCH',
  'specialization.streak.shiny': 'SHINY',
  'specialization.streakValuePct': '+{value}%',
  'specialization.streakValueReserve': '{value}% reserva',
  'specialization.streakPer.exp': '+{value} p.p. de XP da reserva por ponto',
  'specialization.streakPer.loot': '+{value}% de loot por ponto',
  'specialization.streakPer.catch': '+{value}% de captura por ponto',
  'specialization.streakPer.shiny': '+{value}% de progresso Shiny por ponto',
  'specialization.pointsInPath': '{count} ponto(s)',
  'specialization.investPlus': '+ Investir',
  'specialization.killsEyebrow': 'Histórico',
  'specialization.killsTitle': 'Abates por Pokémon',
  'specialization.killsEmpty': 'Nenhum abate registrado ainda. Derrote wilds nas caçadas para preencher este grid.',
  'specialization.killEyebrow': 'Veterania de combate',
  'specialization.killBonus': '+{value}% de XP por derrotas',
  'specialization.killMax': 'Bônus máximo alcançado com {kills} inimigos derrotados.',
  'specialization.killNext': '{kills} derrotas. Faltam {remaining} para o marco de {next}.',
  'specialization.shinyEyebrow': 'Pesquisa Shiny',
  'specialization.shinyTitle': 'A mesma regra para todas as espécies',
  'specialization.shinyRule': 'Cada espécie acumula suas próprias derrotas. O soft pity começa em {start} e cresce até o teto, sem garantia de Shiny.',
  'specialization.shinyBase': 'chance base',
  'specialization.shinyPity': 'início do soft pity',
  'specialization.shinyCapLabel': 'teto da chance',
  'specialization.shinyResearchBonus': 'Pesquisador atual: +{value}% de progresso por derrota',
  'specialization.path': 'Caminho',
  'specialization.next': 'Próximo',
  'specialization.maxRank': 'Nível máximo',
  'specialization.maxed': 'Completo',
  'specialization.invest': 'Investir 1 ponto',
  'specialization.trainer.name': 'Mentor',
  'specialization.trainer.description': 'Seu parceiro equipado continua treinando enquanto o jogo está fechado.',
  'specialization.hunter.name': 'Caçador',
  'specialization.hunter.description': 'Aprimora a quantidade de materiais obtidos nas caçadas.',
  'specialization.catcher.name': 'Capturador',
  'specialization.catcher.description': 'Aumenta a chance final de cada tentativa de captura.',
  'specialization.researcher.name': 'Pesquisador',
  'specialization.researcher.description': 'Acelera a pesquisa Shiny específica de cada espécie.',
  'specialization.effect.trainer': 'Parceiro treina offline a {offline}% do ritmo',
  'specialization.effect.hunter': '+{value}% de loot',
  'specialization.effect.catcher': '+{value}% de chance de captura',
  'specialization.effect.researcher': '+{value}% de progresso Shiny',
  'specialization.respecFree': 'Redefinir grátis ({count})',
  'specialization.respecCost': 'Redefinir por {cost} IdleCoin',
  'specialization.systemsEyebrow': 'Onde estão os outros sistemas?',
  'specialization.systemsTitle': 'Sistemas ativos de progressão',
  'specialization.system.prestige': 'Prestígio',
  'specialization.system.prestigeWhere': 'Perfil do treinador · após o nível 300',
  'specialization.system.mastery': 'Maestria',
  'specialization.system.masteryWhere': 'Meus Pokémon · níveis acima de 300',
  'specialization.system.evolution': 'Evolução',
  'specialization.system.evolutionWhere': 'Meus Pokémon · ao atingir o nível exigido',
  'specialization.system.offline': 'Caça offline',
  'specialization.system.offlineWhere': 'Automação · requer amostra ativa de 5 min',
  'specialization.system.research': 'Pesquisa, qualidade e drops',
  'specialization.system.researchWhere': 'Pokédex · detalhes de cada espécie',
  'specialization.system.combat': 'Speed e iniciativa',
  'specialization.system.combatWhere': 'Caçada · relógios independentes por combatente',
  'specialization.confirmInvest': 'Investir em {name}? O próximo efeito será: {effect}.',
  'specialization.invested': '{name} avançou para o nível {rank}.',
  'specialization.noPointsServer': 'O servidor ainda não registrou um Streak Point disponível. Aguarde a sincronização da hunt e tente novamente.',
  'specialization.notEnoughCoins': 'IdleCoin insuficiente para redefinir a Especialização.',
  'specialization.confirmRespecFree': 'Redefinir todos os pontos usando uma redefinição grátis?',
  'specialization.confirmRespecCost': 'Redefinir todos os pontos por {cost} IdleCoin?',
  'specialization.respecced': 'Pontos de Especialização redefinidos.',
  'specialization.killMilestoneLog': '{kills} inimigos derrotados: bônus permanente de XP chegou a +{value}%.',
  'specialization.killMilestoneToast': 'Veterania: +{value}% de XP permanente!',
  'offline.title': 'Caça offline',
  'offline.hint': 'Descanse na hunt para armar o rendimento offline',
  'offline.requirement': 'Requer 5 minutos de hunt ativa para formar uma amostra.',
  'offline.start': 'Iniciar caça offline',
  'offline.rest': 'Descansar',
  'offline.restHint': 'Para a hunt e arma o rendimento offline. Sem isso, fechar o jogo não paga nada.',
  'offline.restReady': 'Hunt ativa: aperte Descansar para armar o offline e fechar o jogo.',
  'offline.restIdle': 'Entre em uma hunt e aperte Descansar para armar o offline. Fechar sem descansar não paga.',
  'offline.restNeedHunt': 'Comece uma hunt antes de descansar.',
  'offline.restArmed': 'Offline armado. Pode fechar o jogo — volte depois para coletar.',
  'offline.restArmedRisk': 'Offline armado sem poções/revive: a amostra para cedo se o parceiro cair.',
  'offline.restArmFailed': 'Não foi possível armar o offline. Tente de novo.',
  'offline.faintedNoSupplies': 'Seu parceiro caiu sem poção/revive. A amostra da hunt parou.',
  'offline.pending': 'As recompensas estão prontas para coleta.',
  'offline.active': 'A caça offline está ativa. Volte depois para coletar.',
  'offline.ready': 'Amostra pronta: {time} de hunt ativa.',
  'offline.sampling': 'Amostrando a hunt: {time} / 05:00.',
  'offline.notReady': 'Faça pelo menos 5 minutos de hunt antes de ficar offline.',
  'offline.started': 'Caça offline iniciada. Limite atual: {hours}h.',
  'offline.reportEyebrow': 'Relatório offline',
  'offline.reportTitle': 'A hunt continuou',
  'offline.claim': 'Coletar recompensas',
  'offline.time': 'tempo offline',
  'offline.efficiency': 'As recompensas usam 50% da amostra de combate dos últimos 10 minutos. Capturas, pedras e rolagens raras ficam desativadas offline.',
  'offline.noDrops': 'Nenhum drop estável foi gerado neste período.',
  'offline.claimed': 'Recompensas offline coletadas!',
  'offline.serverEfficiency': 'Bem-vindo de volta! Sua hunt rendeu enquanto você esteve fora, a {pct} da sua taxa de farm. Capturas ficam para quando você está jogando.',
  'offline.trainerXp': 'XP do treinador',
  'offline.pokemonXp': 'XP do parceiro',
  'offline.pokemonShare': 'Seu parceiro treinou offline a {pct}% do ritmo, graças a Mentor/VIP.',
  'offline.pokemonLocked': 'Seu parceiro não treina offline. Invista em Mentor (Especialização) ou ative o VIP para liberar até 75% do XP.',
  'offline.reserveShare': 'O restante do time equipado treinou junto: +{xp} XP cada (VIP).',
  'offline.reserveNone': 'Nenhum Pokémon da reserva recebeu XP neste período.',
  'offline.reserveVipOnly': 'A reserva só treina offline com VIP (10% do XP do parceiro).',
  'offline.stopLabel': 'Parou porque',
  'offline.stop.rest': 'você descansou de propósito',
  'offline.stop.rest_at_risk': 'você descansou sem poções/revive',
  'offline.stop.supplies_exhausted': 'acabaram as poções/revive — a amostra offline parou cedo',
  'offline.stop.fainted_no_supplies': 'o parceiro caiu sem poção/revive',
  'offline.gotIt': 'Entendi',
  'offline.serverDisabled': 'Offline desativado com progresso no servidor (evita XP/loot fantasma).',
  'dex.captureDifficulty': 'Dificuldade',
  'dex.possibleDrops': 'Drops possíveis',
  'dex.dropHint': 'Cada item tem chance independente por derrota, com faixa de quantidade.',
  'dex.drop.primaryRole': 'Drop principal',
  'dex.drop.secondaryRole': 'Drop secundário',
  'dex.drop.signatureRole': 'Drop especial',
  'dex.drop.stoneRole': 'Pedra de evolução',
  'dex.drop.lootRole': 'Loot',
  'dex.noDrops': 'Esta espécie não possui drops configurados.',

  'auth.eyebrow': 'CONTA DE TREINADOR',
  'auth.title': 'Entre no mundo de IdleMon',
  'auth.intro': 'Sua conta protege sua identidade e prepara seu acesso ao Mercado Global.',
  'auth.registerTab': 'Criar conta',
  'auth.loginTab': 'Entrar',
  'auth.email': 'E-mail',
  'auth.emailPlaceholder': 'voce@exemplo.com',
  'auth.loginIdentifier': 'E-mail ou nome de usuário',
  'auth.loginIdentifierPlaceholder': 'voce@exemplo.com ou SeuTreinador',
  'auth.trainerName': 'Nome de usuário',
  'auth.trainerNamePlaceholder': 'SeuTreinador',
  'auth.trainerNameHint': '3–16 caracteres: letras, números ou _',
  'auth.password': 'Senha',
  'auth.passwordPlaceholder': 'Mínimo de 8 caracteres',
  'auth.passwordConfirmation': 'Confirmar senha',
  'auth.passwordConfirmationPlaceholder': 'Repita a senha',
  'auth.passwordLoginPlaceholder': 'Sua senha',
  'auth.rulesAcceptPrefix': 'Li e aceito as',
  'auth.rulesLink': 'Regras do Jogo',
  'auth.version': 'versão',
  'auth.create': 'Criar minha conta',
  'auth.login': 'Entrar no jogo',
  'auth.forgotPassword': 'Esqueci minha senha',
  'auth.resetIntro': 'Digite o e-mail da sua conta para receber um link seguro de recuperação.',
  'auth.sendReset': 'Enviar link de recuperação',
  'auth.backToLogin': 'Voltar para entrar',
  'auth.newPasswordIntro': 'Crie uma nova senha para recuperar sua conta.',
  'auth.newPassword': 'Nova senha',
  'auth.saveNewPassword': 'Salvar nova senha',
  'auth.sendingReset': 'Enviando link de recuperação…',
  'auth.resetSent': 'Se esse e-mail estiver cadastrado, o link de recuperação será enviado em instantes.',
  'auth.savingPassword': 'Salvando sua nova senha…',
  'auth.passwordUpdated': 'Senha alterada. Entre novamente com a nova senha.',
  'auth.recoveryReady': 'Link validado. Agora escolha sua nova senha.',
  'auth.betaNote': 'Ambiente beta: o progresso continua salvo neste navegador.',
  'auth.rulesClose': 'Fechar regras',
  'auth.rulesEyebrow': 'REGRAS DO JOGO',
  'auth.rulesTitle': 'Regras preliminares do beta',
  'auth.rulesDraftNote': 'Este texto é preliminar. As regras definitivas serão publicadas antes do beta aberto e terão uma nova versão para aceite.',
  'auth.rulesDraftVersion': 'Versão preliminar {version}',
  'auth.rulesVersion': 'Versão {version}',
  'auth.account': 'Conta',
  'auth.signOut': 'Sair da conta',
  'auth.creating': 'Criando sua conta…',
  'auth.entering': 'Entrando…',
  'auth.loading': 'Verificando sua sessão…',
  'auth.verifyingEmail': 'Confirmando sua conta…',
  'auth.verifyingRecovery': 'Validando seu link de recuperação…',
  'auth.confirmationSent': 'Conta criada, mas ainda não está ativa. Enviamos um link para {email}. Abra o e-mail e confirme sua conta antes de entrar.',
  'auth.emailPendingActivation': 'Essa conta já foi criada, mas ainda não foi ativada. Enviamos um novo link para {email}. Abra o e-mail e confirme sua conta antes de entrar.',
  'auth.emailConfirmed': 'Conta confirmada com sucesso! Agora é só entrar.',
  'auth.errorNameUnavailable': 'Esse nome de usuário já está em uso ou é reservado.',
  'auth.errorNameInvalid': 'Use de 3 a 16 letras, números ou _ no nome de usuário.',
  'auth.errorRules': 'Você precisa ler e aceitar as Regras do Jogo.',
  'auth.errorEmailExists': 'Esse e-mail já tem uma conta ativa. Entre com seu e-mail e senha ou use “Esqueci minha senha”.',
  'auth.errorEmailRate': 'Muitas tentativas de envio de e-mail. Aguarde alguns minutos e tente novamente.',
  'auth.errorCredentials': 'E-mail, nome de usuário ou senha incorretos.',
  'auth.errorLoginRate': 'Muitas tentativas de login. Aguarde alguns minutos e tente novamente.',
  'auth.errorEmailUnconfirmed': 'Sua conta ainda não foi ativada. Abra o link de confirmação que enviamos para o seu e-mail antes de entrar.',
  'auth.errorLinkExpired': 'Este link de confirmação expirou ou já foi usado. Volte em “Criar conta”, cadastre o mesmo e-mail e enviaremos um link novo.',
  'auth.errorRecoveryExpired': 'Este link de recuperação expirou ou já foi usado. Peça outro em “Esqueci minha senha”.',
  'auth.errorProfileMissing': 'Sua conta entrou, mas o perfil de treinador não foi encontrado. Recarregue a página; se persistir, avise o suporte.',
  'auth.errorUserBanned': 'Esta conta está suspensa. Fale com o suporte para mais detalhes.',
  'auth.errorSignupDisabled': 'A criação de contas está temporariamente fechada. Tente novamente mais tarde.',
  'auth.errorSamePassword': 'A nova senha precisa ser diferente da anterior.',
  'auth.errorCaptcha': 'Conclua a verificação de segurança e tente novamente.',
  'auth.errorNetwork': 'Não foi possível alcançar o servidor. Verifique sua conexão.',
  'auth.errorGeneric': 'Não foi possível concluir a operação. Tente novamente.',
  'auth.errorIpLimit': 'Muitas contas já foram criadas a partir da sua rede (mesmo IP). Por segurança, aguarde 24h e tente novamente.',
  'auth.errorServerInternal': 'O servidor encontrou um erro ao processar sua conta. Tente novamente; se persistir, avise o suporte.',
  'auth.errorEmailSend': 'Não foi possível enviar o e-mail de confirmação para esse endereço. Tente novamente em alguns minutos; se persistir, avise o suporte.',
  'auth.errorPasswordWeak': 'Essa senha já apareceu em vazamentos de dados e é fácil de adivinhar. Escolha outra, misturando letras, números e símbolos.',
  'auth.checkingName': 'Verificando disponibilidade…',
  'auth.nameAvailable': 'Nome de usuário disponível!',
  'auth.errorEmail': 'Digite um e-mail válido.',
  'auth.errorPassword': 'A senha precisa ter pelo menos 8 caracteres.',
  'auth.errorPasswordMatch': 'As senhas não coincidem.',
  'auth.errorBackend': 'O serviço de contas ainda não está disponível. Tente novamente em instantes.',
  'auth.sessionSuperseded': 'Sua conta entrou em outro dispositivo. Esta sessão foi encerrada.',
  'auth.sessionRequired': 'Sessão inválida. Entre novamente.',
  'auth.sessionConflictEyebrow': 'SESSÃO ATIVA ENCONTRADA',
  'auth.sessionConflictTitle': 'Sua conta já está aberta em outro navegador',
  'auth.sessionConflictBody': 'Para proteger seu progresso, apenas um navegador pode jogar com esta conta por vez.',
  'auth.sessionConflictNote': 'Você pode assumir neste navegador ou manter a sessão que já está aberta. Nenhuma opção mantém dois jogos ativos.',
  'auth.sessionConflictKeep': 'Manter sessão existente',
  'auth.sessionConflictTakeover': 'Jogar neste navegador',
  'auth.sessionConflict': 'Existe outra sessão ativa. Escolha qual navegador deve continuar.',
  'auth.sessionConflictKept': 'A sessão existente foi mantida. Este navegador foi desconectado.',
  'auth.sessionConflictChanged': 'A sessão ativa mudou enquanto você decidia. Escolha novamente.',

  'starter.eyebrow': 'Sua jornada começa agora',
  'starter.title': 'Escolha seu Pokémon inicial',
  'starter.hint': 'Ele será o líder do seu time — quem caça nas hunts. Os outros virão com a captura.',
  'starter.step1Title': 'Escolha seu treinador',
  'starter.step1Hint': 'Escolha a aparência e pinte cada peça da roupa.',
  'starter.step2Title': 'Escolha seu Pokémon inicial',
  'starter.step2Hint': 'Ele será o líder do seu time — quem caça nas hunts. Os outros virão com a captura.',
  'starter.step3Title': 'Escolha seu Pokémon inicial',
  'starter.step3Hint': 'Ele será o líder do seu time — quem caça nas hunts. Os outros virão com a captura.',
  'starter.save': 'Seu progresso é salvo neste navegador.',
  'starter.picked': '{name} agora é seu parceiro!',
  'starter.chosen': '✓ Escolhido',
  'starter.regionTitle': 'Escolha uma região',
  'starter.region.kanto': 'Kanto',
  'starter.region.johto': 'Johto',
  'starter.region.hoenn': 'Hoenn',
  'starter.region.sinnoh': 'Sinnoh',
  'starter.trainerTitle': 'Escolha seu treinador',
  'starter.lookTitle': 'Escolha um visual',
  'starter.colorsTitle': 'Cores da roupa',
  'starter.colorsHint': 'Cada slot pinta uma região de tecido deste visual. A pele do personagem não muda.',
  'starter.color.head': 'Cabelo / acessório',
  'starter.color.body': 'Roupa principal',
  'starter.color.legs': 'Roupa secundária',
  'starter.color.feet': 'Detalhe / calçado',
  'starter.boy': 'Menino',
  'starter.girl': 'Menina',
  'starter.nameLabel': 'Nome do treinador',
  'starter.namePlaceholder': 'Seu nome',
  'starter.next': 'Avançar',
  'starter.back': 'Voltar',
  'starter.start': 'Começar a jornada',
  'starter.needStarter': 'Escolha um Pokémon inicial.',
  'starter.needLook': 'Escolha uma aparência.',
  'starter.needName': 'Digite um nome (2–16 caracteres).',
  'starter.grassPoison': 'PLANTA · VENENO',
  'starter.fire': 'FOGO',
  'starter.water': 'ÁGUA',
  'starter.initialMove': 'Golpe inicial',

  'looks.trainer': 'Treinador',
  'looks.elite': 'Elite',
  'looks.adventurer': 'Aventureiro',
  'looks.atletic': 'Atlético',
  'looks.punk': 'Punk',
  'looks.mercenary': 'Mercenário',
  'looks.catcher': 'Capturador',
  'looks.rapper': 'Rapper',
  'looks.jamaican': 'Jamaicano',
  'looks.oriental': 'Oriental',
  'looks.rocket': 'Rocket',
  'looks.business': 'Executivo',
  'looks.fisher': 'Pescador',
  'looks.hiker': 'Trilha',
  'looks.police': 'Policial',
  'looks.veteran': 'Veterano',
  'looks.psychic': 'Psíquico',

  'log.ready': 'A jornada está pronta para começar.',
  'log.leveled': '{name} alcançou o nível {level}.',
  'log.trainerLeveled': 'Você chegou ao nível {level}.',
  'log.learned': 'aprendeu {move}.',
  'log.lootReceived': 'Loot recebido: {items}',
  'log.learnedToast': '{name} aprendeu {move}!',
  'log.defeatedXp': 'derrotado · +{xp} EXP',
  'log.defeatedDrop': 'derrotado · +{xp} EXP · drop: {drops}',
  'log.defeatedRare': 'derrotado · +{xp} EXP · 💎 drop raro: {drops}',
  'log.rareToast': '💎 Raro! {name} dropou {item}!',
  'log.notVip': '{name} não está no filtro VIP.',
  'log.noBall': 'Você não tem {ball} disponível.',
  'log.noBallToast': 'Nenhuma {ball} no inventário.',
  'log.escaped': '{name} escapou da {ball} ({chance}% · {difficulty}).',
  'log.noEncounter': '{name} sumiu da fila do servidor — captura cancelada (sem gastar bola).',
  'log.noEncounterToast': 'Encontro ainda sincronizando. Tente de novo em instantes.',
  'log.ghostRestored': '{count} captura(s) rara(s) recuperada(s) do histórico.',
  'log.captured': 'capturado no nível {level}! {rarity} · IV {iv}',
  'log.capturedToast': '{name} capturado no nível {level} · {rarity}!',
  'log.potionUsed': '{name} usou {item} (+{hp} HP).',
  'log.reviveUsed': '{name} voltou com um Revive!',
  'log.sold': 'vendido · +{total} IdleCoin',
  'log.partnerSeeking': '{name} · Seu Pokémon',

  'toast.pickPotion': 'Selecione uma poção disponível no painel de poção automática.',
  'toast.potionUsed': '{name} usada!',
  'toast.emptyPotion': 'Nenhuma poção no inventário. Compre algumas na loja.',
  'toast.revived': 'Revive usado — a hunt continua!',

  'types.elétrico': 'Elétrico',
  'types.fogo': 'Fogo',
  'types.água': 'Água',
  'types.planta': 'Planta',
  'types.inseto': 'Inseto',
  'types.voador': 'Voador',
  'types.normal': 'Normal',
  'types.psíquico': 'Psíquico',
  'types.pedra': 'Pedra',
  'types.terra': 'Terra',
  'types.fantasma': 'Fantasma',
  'types.dragão': 'Dragão',
  'types.lutador': 'Lutador',
  'types.veneno': 'Veneno',
  'types.sombrio': 'Sombrio',
  'types.aço': 'Aço',
  'types.gelo': 'Gelo',
  'types.fada': 'Fada',

  'rarities.Comum': 'Comum',
  'rarities.Incomum': 'Incomum',
  'rarities.Raro': 'Raro',
  'rarities.Épico': 'Épico',
  'rarities.Lendário': 'Lendário',
  'rarities.Mítico': 'Mítico',
  'rarities.Celestial': 'Celestial',
  'rarities.Ancião': 'Anciã',
  'rarities.Secreto': 'Secreto',
  'rarities.Inicial': 'Inicial',

  'catch.easy': 'Fácil',
  'catch.medium': 'Médio',
  'catch.hard': 'Difícil',
  'catch.veryHard': 'Muito difícil',

  'maps.saffron-meadows': 'Pradarias de Saffron',
  'maps.viridian-trail': 'Trilha de Viridian',
  'maps.pewter-forest': 'Florestas de Pewter',
  'maps.pewter-woods': 'Bosques de Pewter',
  'maps.rock-tunnel-swamp': 'Pântanos do Rock Tunnel',
  'maps.rock-tunnel-caves': 'Cavernas do Rock Tunnel',
  'maps.cinnabar-volcano': 'Vulcão de Cinnabar',
  'maps.cinnabar-ashes': 'Cinzas de Cinnabar',
  'maps.sevii-islands': 'Ilhas Lendárias',
  'maps.glacial-sea': 'Mar Glacial',
  'maps.supreme-threshold': 'Limiar Supremo',
  'maps.ashen-spire': 'Pico de Cinzas',
  'maps.obsidian-court': 'Corte de Obsidiana',
  'maps.eclipse-rift': 'Fenda do Eclipse',
  'maps.final-horizon': 'Horizonte Final',

  'items.pokeball.name': 'Poké Ball',
  'items.old-rod.name': 'Vara Velha',
  'items.old-rod.desc': 'Pesca aquáticos básicos (faixas até Nv.40).',
  'items.good-rod.name': 'Boa Vara',
  'items.good-rod.desc': 'Pesca aquáticos até faixas médias (Nv.150).',
  'items.super-rod.name': 'Super Vara',
  'items.super-rod.desc': 'Pesca aquáticos em qualquer faixa.',
  'items.pokeball.desc': '1× taxa de captura.',
  'items.greatball.name': 'Great Ball',
  'items.greatball.desc': '2× taxa de captura.',
  'items.superball.name': 'Super Ball',
  'items.superball.desc': '3× taxa de captura.',
  'items.ultraball.name': 'Ultra Ball',
  'items.ultraball.desc': '4× taxa de captura.',
  'items.masterball.name': 'Master Ball',
  'items.masterball.desc': '100× taxa de captura. Sempre captura.',
  'items.potion.name': 'Poção',
  'items.potion.desc': 'Restaura 30% do HP de um Pokémon.',
  'items.great-potion.name': 'Super Poção',
  'items.great-potion.desc': 'Restaura 60% do HP de um Pokémon.',
  'items.ultra-potion.name': 'Hiper Poção',
  'items.ultra-potion.desc': 'Restaura 80% do HP de um Pokémon.',
  'items.hyper-potion.name': 'Poção Máxima',
  'items.hyper-potion.desc': 'Restaura 90% do HP de um Pokémon.',
  'items.full-restore.name': 'Restauração Total',
  'items.full-restore.desc': 'Restaura totalmente o HP de um Pokémon.',
  'items.medicine.name': 'Antídoto',
  'items.medicine.desc': 'Cura o envenenamento de um Pokémon.',
  'items.revive.name': 'Revive',
  'items.revive.desc': 'Revive um Pokémon desmaiado.',
  'items.leaf-stone.name': 'Pedra da Folha',
  'items.leaf-stone.desc': 'Evolui Pokémon do tipo Planta.',
  'items.water-stone.name': 'Pedra da Água',
  'items.water-stone.desc': 'Evolui Pokémon do tipo Água.',
  'items.thunder-stone.name': 'Pedra do Trovão',
  'items.thunder-stone.desc': 'Evolui Pokémon do tipo Elétrico.',
  'items.fire-stone.name': 'Pedra do Fogo',
  'items.fire-stone.desc': 'Evolui Pokémon do tipo Fogo.',
  'items.sun-stone.name': 'Pedra do Sol',
  'items.sun-stone.desc': 'Evolui Pokémon que amam o sol.',
  'items.moon-stone.name': 'Pedra da Lua',
  'items.moon-stone.desc': 'Referência à lua. Evolui alguns Pokémon.',
  'items.ice-stone.name': 'Pedra do Gelo',
  'items.ice-stone.desc': 'Evolui Pokémon do tipo Gelo.',
  'items.shiny-stone.name': 'Pedra Shiny',
  'items.shiny-stone.desc': 'Evolui Pokémon shiny.',
  'items.venom-stone.name': 'Pedra do Veneno',
  'items.venom-stone.desc': 'Evolui Pokémon do tipo Veneno.',
  'items.rock-stone.name': 'Pedra da Rocha',
  'items.rock-stone.desc': 'Evolui Pokémon do tipo Pedra.',
  'items.punch-stone.name': 'Pedra do Soco',
  'items.punch-stone.desc': 'Evolui Pokémon do tipo Lutador.',
  'items.cocoon-stone.name': 'Pedra do Casulo',
  'items.cocoon-stone.desc': 'Evolui Pokémon de casulo.',
  'items.crystal-stone.name': 'Pedra de Cristal',
  'items.crystal-stone.desc': 'Evolui Pokémon de cristal.',
  'items.darkness-stone.name': 'Pedra da Escuridão',
  'items.darkness-stone.desc': 'Evolui Pokémon do tipo Sombrio.',
  'items.earth-stone.name': 'Pedra da Terra',
  'items.earth-stone.desc': 'Evolui Pokémon do tipo Terra.',
  'items.enigma-stone.name': 'Pedra Enigma',
  'items.enigma-stone.desc': 'Evolui Pokémon do tipo Psíquico.',
  'items.heart-stone.name': 'Pedra do Coração',
  'items.heart-stone.desc': 'Evolui Pokémon do tipo Fada.',
  'items.drop-electric-box.name': 'Caixa Elétrica',
  'items.drop-essence-fire.name': 'Essência de Fogo',
  'items.drop-water-gem.name': 'Gema de Água',
  'items.drop-seed.name': 'Semente',
  'items.drop-bug-antenna.name': 'Antena de Inseto',
  'items.drop-feather.name': 'Pena',
  'items.drop-tooth.name': 'Dente',
  'items.drop-twisted-spoon.name': 'Colher Torcida',
  'items.drop-stone-orb.name': 'Orbe de Pedra',
  'items.drop-bone.name': 'Osso',
  'items.drop-ghost-trace.name': 'Rastro Fantasma',
  'items.drop-ghost-essence.name': 'Essência Fantasma',
  'items.drop-dragon-tooth.name': 'Presa de Dragão',
  'items.drop-champion-belt.name': 'Cinto de Campeão',
  'items.drop-poison-bottle.name': 'Frasco de Veneno',
  'items.drop-fox-tail.name': 'Cauda de Raposa',
  'items.drop-iron-pin.name': 'Pino de Ferro',
  'items.drop-ice-orb.name': 'Orbe de Gelo',
  'items.drop-luck-medal.name': 'Medalha da Sorte',
  'toast.removeFromTeam': "Remova o Pokémon da equipe antes de vender.",
  'toast.nothingToSell': "Nada para vender.",
  'toast.sellStockMismatch': "Inventário dessincronizado com o servidor. Quantidades atualizadas — tente vender de novo.",
  'toast.noEligiblePokemon': "Nenhum Pokémon elegível para venda.",
  'toast.unlockToSell': "Destrave o cadeado (sync) e tente vender de novo.",
  'toast.sellPokemonBatch': "Pokémon demais selecionados. Tente de novo — a venda vai em lotes.",
  'toast.teamFull': "Sua equipe já tem seis Pokémon. Remova um reserva primeiro.",
  'toast.teamSyncFailed': "Falha ao salvar o time no servidor.",
  'toast.cannotEvolveYet': "Este Pokémon ainda não pode evoluir.",
  'toast.evolutionUnavailable': "A evolução não está mais disponível.",
  'toast.stoneUnavailable': "Essa pedra não está disponível.",
  'team.movesPending': "Alterações pendentes",
  'team.movesSaved': "Golpes salvos",
  'team.levelLabel': "Nível {level}",
  'team.status': "STATUS",
  'auto.potionStock': "{count} poção(ões) disponível(is)",
  'auto.potionNone': "Nenhuma poção no inventário.",
  'battle.turnEnemy': "Turno inimigo",
  'battle.turnPlayer': "Seu turno",
  'map.unlockAt': "Desbloqueia no nível {level}",
  'map.routeUnlocked': "Rota liberada",
  'log.soldFor': "vendido por {total} IdleCoin.",
  'log.soldCoins': "vendido · +{total} IdleCoin",
  'log.soldMany': "vendidos {count} · +{total} IdleCoin",
  'dialog.shop': "Loja",
  'col.empty': "Nenhum Pokémon capturado ainda.<br>Ative a auto-captura e aventure-se em uma rota.",
  'col.noMatch': "Nenhum pokémon corresponde aos filtros.<br>Ajuste ou limpe os filtros acima.",
  'col.equip': "Equipar na equipe",
  'col.unequip': "Remover da equipe",
  'col.equippedToast': "{name} foi equipado na equipe!",
  'col.removedToast': "{name} foi removido da equipe.",
  'col.detailStatus': "Status · Nv. {level}",
  'evo.titleName': "Evoluir {name}",
  'sys.pixiOn': "Renderer PixiJS ativo — Saffron em tiles.",
  'sys.pixiOff': "Pixi indisponível — usando PNG.",
  'sys.bootDegraded': "Parte do carregamento falhou. Recarregue (F5) se algo não responder.",
  'sys.movesFail': "Golpes: falha ao carregar base.",
  'sys.updateAvailable': 'Nova versão disponível — o jogo será atualizado em instantes.',
  'sys.updateNow': 'Atualizar agora',
  'sys.collisionFail': "Colisão detalhada da cidade indisponível.",
  'battle.goingTo': "{attacker} INDO ATÉ {target}",
  'battle.fightingWith': "{attacker} LUTANDO COM {target}",
  'battle.fallbackAttack': "Ataque",
  'battle.unaffected': "não afetou",
  'battle.superEffective': "Super eficaz!",
  'battle.notEffective': "Pouquíssimo eficaz...",
  'hunt.territory': "Território {type}",
  'hunt.levelPokemon': "Pokémon de nível {level}",
  'team.equippedMoves': "GOLPES EQUIPADOS",
  'team.makePrincipal': "Tornar {name} o Pokémon principal",
  'team.equipAsPrincipal': "Equipar como principal",
  'team.principal': "PRINCIPAL",
  'team.promotedToast': "{name} agora é seu Pokémon principal!",
  'team.movesHint': "Equipe até quatro golpes. No combate, o Pokémon usa automaticamente o melhor golpe pronto; golpes usados recarregam em turnos.",
  'moves.oneTurn': "1 turno",
  'moves.turns': "{count} turnos",
  'moves.alwaysReady': "Sempre disponível",
  'moves.ready': "PRONTA",
  'moves.rechargeLabel': "Recarga: {turns}",
  'moves.rotationAria': "Golpes equipados e recarga em turnos",
  'team.ivsTotal': "Total {value}",
  'col.resultsOf': "{filtered} de {total} pokémon",
  'col.ivsTotal': "IVs · total {value}",
  'market.title': "Mercado Global",
  'market.subtitle': "Compre, venda e negocie com jogadores de todo o mundo.",
  'market.tab.buy': "Comprar",
  'market.tab.sell': "Anunciar",
  'market.tab.mine': "Meus anúncios",
  'market.categories': "Categorias",
  'market.category.all': "Todos",
  'market.category.item': "Itens",
  'market.category.stone': "Pedras",
  'market.category.ball': "Poké Bolas",
  'market.category.loot': "Recursos",
  'market.category.pokemon': "Pokémon",
  'market.searchPlaceholder': "Buscar item ou Pokémon...",
  'market.sort': "Ordenação",
  'market.sort.recent': "Mais recentes",
  'market.sort.priceAsc': "Menor preço",
  'market.sort.priceDesc': "Maior preço",
  'market.clear': "Limpar",
  'market.cards': "Cards",
  'market.rows': "Linhas",
  'market.filters': "Filtros avançados",
  'market.any': "Qualquer",
  'market.filter.currency': "Moeda",
  'market.filter.ivMin': "IV mínimo",
  'market.filter.ivMax': "IV máximo",
  'market.filter.levelMin': "Nível mínimo",
  'market.filter.levelMax': "Nível máximo",
  'market.filter.type': "Tipo",
  'market.filter.rarity': "Raridade",
  'market.filter.shiny': "Somente Shiny",
  'market.currency': "Moeda",
  'market.currency.idlecoin': "IdleCoin",
  'market.currency.emerald': "Emerald",
  'market.item': "Item",
  'market.items': "Itens · Poké Bolas · Recursos",
  'market.pokemon': "Pokémon",
  'market.groupSummary': "{qty}× · {sellers} vendedores",
  'market.fromPrice': "a partir de {price} {currency}/un",
  'market.offerOnly': "Somente oferta",
  'market.power': "Poder",
  'market.details': "Detalhes do anúncio",
  'market.selectListing': "Selecione um anúncio para ver os detalhes.",
  'market.level': "Nível",
  'market.unitPrice': "Preço unitário",
  'market.quantity': "Quantidade",
  'market.total': "Total",
  'market.multipleSellers': "{count} vendedores disponíveis",
  'market.seller': "Vendedor",
  'market.buyNow': "Comprar agora",
  'market.makeOffer': "Ofertar",
  'market.showing': "Mostrando {start}–{end} de {total} resultados",
  'market.noResults': "Nenhum anúncio encontrado",
  'market.noResultsHint': "Ajuste os filtros ou tente outra busca.",
  'market.deliveriesReady': "{count} entrega(s) pronta(s) para resgate",
  'market.claimNow': "Resgatar agora",
  'market.deliveriesClaimed': "Entregas resgatadas no seu save.",
  'market.sellTitle': "Anunciar no Mercado",
  'market.sellSubtitle': "Escolha um recurso do save ou da custódia e defina as condições.",
  'market.localSave': "No save local",
  'market.inCustody': "Em custódia",
  'market.selectAsset': "Selecione um item ou Pokémon para anunciar.",
  'market.listAsset': "Configurar anúncio",
  'market.onlyOffers': "Somente oferta",
  'market.allowOffers': "Aceitar ofertas",
  'market.fee': "Taxa ({percent}%)",
  'market.custodyWarning': "O Pokémon fica em custódia, fora do time e do depósito, até vender ou cancelar.",
  'market.depositWarning': "O recurso será transferido para a custódia segura antes do anúncio.",
  'market.listPokemon': "Anunciar Pokémon",
  'market.listNow': "Anunciar",
  'market.withdraw': "Retirar da custódia",
  'market.noItems': "Nenhum item elegível.",
  'market.noPokemon': "Nenhum Pokémon elegível.",
  'market.myListings': "Meus anúncios",
  'market.myListingsSubtitle': "Acompanhe estoque, preço e ofertas pendentes.",
  'market.noListings': "Você não tem anúncios ativos.",
  'market.pendingOffer': "Em oferta",
  'market.active': "Ativo",
  'market.cancel': "Cancelar",
  'market.secureCustody': "Custódia e liquidação protegidas pelo servidor",
  'market.pulseActive': 'Ativos',
  'market.pulseRequests': 'Pedidos',
  'market.pulseOffers': 'Ofertas',
  'market.pulseProtected': 'custódia protegida',
  'market.purchaseComplete': "Compra concluída. A entrega está pronta.",
  'market.listingCreated': "Anúncio criado.",
  'market.listingCancelled': "Anúncio cancelado e custódia devolvida.",
  'market.withdrawn': "Recurso devolvido ao save.",
  'market.error.generic': "Não foi possível concluir a operação do mercado.",
  'market.error.wallet_migration_required': "A carteira aguarda a migração inicial de IdleCoin.",
  'market.error.migration_amnesty_pending': "A migração da carteira aguarda a configuração do teto de anistia.",
  'market.error.insufficient_market_balance': "Saldo insuficiente para esta compra.",
  'market.error.insufficient_listing_fee': "Saldo insuficiente para pagar a taxa do anúncio.",
  'market.error.item_deposit_cap_reached': "O limite diário de depósito deste item foi atingido.",
  'market.error.pokemon_deposit_cap_reached': "O limite diário desta raridade foi atingido.",
  'market.error.pokemon_not_in_save': "Este Pokémon não consta no seu save sincronizado. Aguarde alguns segundos e tente de novo.",
  'market.error.item_not_in_save': "Esta quantidade não consta no seu save sincronizado. Aguarde alguns segundos e tente de novo.",
  'market.error.listing_not_buyable': "Este anúncio não está mais disponível.",
  'market.error.bulk_quantity_unavailable': "Não há quantidade suficiente dentro do preço escolhido.",
  'market.error.delivery_not_claimable': "Esta entrega já foi resgatada ou não está disponível.",
  'market.tab.requests': "Solicitações",
  'market.tab.offers': "Ofertas",
  'market.tab.history': "Histórico",
  'market.tab.ignored': "Ignorados",
  'market.ignoreSeller': "Ignorar este vendedor",
  'market.pokemonOnlyOffer': "Oferta em Pokémon",
  'market.offerFrom': "Recebida de {name}",
  'market.offerTo': "Enviada para {name}",
  'market.offerSummary': "{qty}× · {pokemon} Pokémon incluído(s)",
  'market.accept': "Aceitar",
  'market.reject': "Recusar",
  'market.withdrawOffer': "Retirar oferta",
  'market.offersTitle': "Ofertas",
  'market.offersSubtitle': "Dinheiro e Pokémon ficam em escrow até a resposta.",
  'market.received': "Recebidas",
  'market.sent': "Enviadas",
  'market.noReceivedOffers': "Nenhuma oferta recebida.",
  'market.noSentOffers': "Nenhuma oferta enviada.",
  'market.addPokemon': "Adicionar Pokémon (opcional)",
  'market.noPokemonForOffer': "Nenhum Pokémon disponível para oferta.",
  'market.offerEscrowWarning': "O saldo e os Pokémon oferecidos ficam protegidos pelo servidor até aceitar, recusar ou retirar.",
  'market.sendOffer': "Enviar oferta",
  'market.offerSent': "Oferta enviada.",
  'market.offerAccepted': "Oferta aceita e liquidada.",
  'market.offerRejected': "Oferta recusada e escrow devolvido.",
  'market.offerWithdrawn': "Oferta retirada e escrow devolvido.",
  'market.requestBy': "Solicitado por {name}",
  'market.requestQtyPrice': "{qty}× por {price} {currency}/un",
  'market.anyPokemon': "Sem filtros adicionais",
  'market.fulfill': "Atender",
  'market.myRequest': "Minha solicitação",
  'market.escrowActive': "Saldo em escrow",
  'market.requestsTitle': "Solicitações",
  'market.requestsSubtitle': "Ordens de compra financiadas e atendíveis direto do inventário.",
  'market.searchRequests': "Buscar solicitações...",
  'market.openRequests': "Solicitações abertas",
  'market.noRequests': "Nenhuma solicitação aberta.",
  'market.myRequests': "Minhas solicitações",
  'market.noMyRequests': "Você não tem solicitações ativas.",
  'market.createRequest': "Criar solicitação",
  'market.assetType': "Tipo de recurso",
  'market.itemSlug': "Código do item",
  'market.species': "Espécie",
  'market.requestEscrowWarning': "O valor total fica em escrow e volta automaticamente ao cancelar ou expirar.",
  'market.publishRequest': "Publicar solicitação",
  'market.fulfillRequest': "Atender solicitação",
  'market.noEligibleAsset': "Nenhum recurso elegível no save ou na custódia.",
  'market.fulfillFor': "Atender por {price} {currency}",
  'market.requestPublished': "Solicitação publicada com saldo em escrow.",
  'market.requestFulfilled': "Solicitação atendida. Pagamento recebido.",
  'market.requestCancelled': "Solicitação cancelada e saldo devolvido.",
  'market.historyTitle': "Histórico",
  'market.historySubtitle': "Compras, vendas e referências recentes de preço.",
  'market.role.buyer': "Compra",
  'market.role.seller': "Venda",
  'market.noHistory': "Nenhuma transação concluída.",
  'market.recentMedians': "Medianas dos últimos 30 dias",
  'market.tradeCount': "{count} negócio(s)",
  'market.noMedians': "Ainda não há dados suficientes.",
  'market.ignoredTitle': "Jogadores ignorados",
  'market.ignoredSubtitle': "Anúncios e solicitações desses jogadores ficam ocultos.",
  'market.unignore': "Deixar de ignorar",
  'market.noIgnored': "Você não ignora nenhum jogador.",
  'market.ignored': "Jogador ignorado.",
  'market.unignored': "Jogador removido dos ignorados.",
  'market.error.emptyOffer': "Inclua IdleCoin, Emerald ou ao menos um Pokémon.",
  'market.error.insufficient_offer_balance': "Saldo insuficiente para financiar esta oferta.",
  'market.error.insufficient_request_balance': "Saldo insuficiente para financiar esta solicitação.",
  'market.error.listing_not_offerable': "Este anúncio não aceita mais ofertas.",
  'market.error.offer_no_longer_settleable': "A oferta não pode mais ser liquidada.",
  'market.error.request_not_fulfillable': "Esta solicitação não pode mais ser atendida.",
  'market.searchAssets': "Buscar no inventário e na custódia...",
  'market.searchPokemon': "Buscar Pokémon para oferecer...",
  'market.error.market_rate_limit_exceeded': "Muitas operações em sequência. Aguarde um instante e tente novamente.",

  'tut.next': 'Próximo',
  'tut.skip': 'Pular tutorial',
  'tut.skipConfirm': 'Pular o tutorial? Você pode reabrir em Configurações.',
  'tut.skipYes': 'Pular',
  'tut.skipNo': 'Continuar',
  'tut.restart': 'Rever tutorial',
  'tut.progress': '{current}/{total}',
  'tut.veteranToast': 'Tutorial disponível em Configurações → Rever tutorial.',
  'tut.welcome.title': 'Bem-vindo a IdleMon',
  'tut.welcome.body': 'Vamos dar uma volta rápida pelas peças principais. Você pode pular a qualquer momento.',
  'tut.cityWalk.title': 'Saffron City',
  'tut.cityWalk.body': 'Esta é a zona segura. Ande com W A S D e fale com os NPCs quando precisar.',
  'tut.teamHud.title': 'Sua equipe',
  'tut.teamHud.body': 'Aqui fica o time ativo. O parceiro principal lidera os combates automáticos.',
  'tut.partnerBars.title': 'HP e XP',
  'tut.partnerBars.body': 'A barra verde é a vida; a de baixo é a experiência do Pokémon.',
  'tut.currency.title': 'IdleCoin e Emerald',
  'tut.currency.body': 'IdleCoin vem de batalhas e vendas. Emerald é a moeda premium.',
  'tut.openAtlas.title': 'Atlas de caça',
  'tut.openAtlas.body': 'Abra o Atlas para escolher onde caçar.',
  'tut.pickRoute.title': "Escolha o tipo",
  'tut.pickRoute.body': "Comece pelo tipo destacado. Cada tipo possui sua própria lista de Pokémon.",
  'tut.pickLevelOne.title': "Escolha o nível 1",
  'tut.pickLevelOne.body': "Selecione Lv. 1: é a faixa segura para aprender como a caça funciona.",
  'tut.pickSpecies.title': "Escolha o Pokémon",
  'tut.pickSpecies.body': "Agora escolha qual Pokémon de nível 1 você quer procurar.",
  'tut.startHunt.title': "Inicie a caça",
  'tut.startHunt.body': "Tudo pronto. Toque em Hunt para viajar até a rota escolhida.",
  'tut.battleAuto.title': 'Combate automático',
  'tut.battleAuto.body': 'O jogo caça sozinho. Você só observa o status e intervém quando quiser.',
  'tut.enemyHud.title': 'Pokémon selvagem',
  'tut.enemyHud.body': 'Nome, tipo e HP do oponente aparecem aqui durante a luta.',
  'tut.restButton.title': 'Descansar',
  'tut.restButton.body': 'Use Descansar para armar recompensas offline quando sair do jogo.',
'tut.capturePanel.title': "Painel de captura",
'tut.capturePanel.body': "Quando um selvagem desmaia, aparece aqui. Escolha a bola e tente capturar.",
'tut.captureBall.title': "Jogue uma bola",
'tut.captureBall.body': "Escolha uma bola acima e toque em Lançar para tentar a captura.",
'tut.navCaptures.title': "Histórico de capturas",
'tut.navCaptures.body': "Abra o registro das capturas recentes.",
'tut.navMyPokemon.title': "Meus Pokémon",
'tut.navMyPokemon.body': "Gerencie a equipe e veja detalhes de cada membro.",
'tut.teamDetail.title': "Detalhe do time",
'tut.teamDetail.body': "Aqui você vê IVs, moves e promove reservas.",
'tut.navInventory.title': "Inventário",
'tut.navInventory.body': "Abra a mochila para ver bolas, poções e loot.",
'tut.potions.title': "Poções",
'tut.potions.body': "Use poções para recuperar o HP do parceiro no meio da caçada.",
'tut.navAutomation.title': "Automação",
'tut.navAutomation.body': "Ajuste cura e captura automáticas.",
'tut.autoPotion.title': "Auto-poção",
'tut.autoPotion.body': "Ligue para curar sozinho quando o HP cair.",
'tut.autoCaptureVip.title': "Auto-captura (VIP)",
'tut.autoCaptureVip.body': "Capturar automaticamente após o KO é um benefício VIP. No plano free, use as bolas do painel.",
'tut.healNurse.title': "Nurse Joy",
'tut.healNurse.body': "Na cidade, a Nurse Joy cura o time de graça.",
'tut.shopNpc.title': "Loja do Sam",
'tut.shopNpc.body': "Abra a loja para comprar suprimentos ou vender loot.",
'tut.shopSell.title': "Vender drops",
'tut.shopSell.body': "Na aba Vender você transforma loot em IdleCoin.",
'tut.deposit.title': "Depósito",
'tut.deposit.body': "Guarde itens e mova Pokémon entre a equipe e o Box.",
'tut.depositBox.title': "Box",
'tut.depositBox.body': "Pokémon extras ficam no Box até você precisar deles.",
'tut.profile.title': "Perfil do treinador",
'tut.profile.body': "Acompanhe nível, prestígio e progresso.",
'tut.navSpecialization.title': "Especialização",
'tut.navSpecialization.body': "Invista pontos de talento para fortalecer o estilo de jogo.",
'tut.specInvest.title': "Árvores de talento",
'tut.specInvest.body': "Cada árvore melhora um estilo. Você ganha o primeiro ponto no nível 50.",
'tut.systemsDiscovery.title': "Sistemas",
'tut.systemsDiscovery.body': "Atalhos para ginásios, raids, crafting e mais.",
'tut.navPokedex.title': "Pokédex",
'tut.navPokedex.body': "Consulte espécies, rotas e o que você já registrou.",
'tut.navSystems.title': "Hub de sistemas",
'tut.navSystems.body': "Abra o hub para upgrades e modos avançados.",
'tut.hubUpgrades.title': "Upgrades",
'tut.hubUpgrades.body': "Melhorias permanentes que aceleram o progresso.",
'tut.navAltar.title': "Altar shiny",
'tut.navAltar.body': "Ofereça cartas shiny no altar para bônus raros.",
'tut.navBreeding.title': "Breeding",
'tut.navBreeding.body': "Cruze Pokémon para ovos com IVs melhores.",
'tut.dailyGift.title': "Presente diário",
'tut.dailyGift.body': "Entre todo dia para manter a sequência de recompensas.",
'tut.gamePass.title': "Game Pass",
'tut.gamePass.body': "Passe de temporada com recompensas free e premium. Só informativo — sem pressão para comprar.",
'tut.market.title': "Mercado",
'tut.market.body': "Negocie com outros jogadores.",
'tut.chat.title': "Chat",
'tut.chat.body': "Fale com o mundo, troque dicas e mostre capturas.",
'tut.compareLab.title': "Laboratório",
'tut.compareLab.body': "Compare dois Pokémon lado a lado.",
'tut.emeraldStore.title': "Loja de Esmeraldas",
'tut.emeraldStore.body': "Emerald compra cosméticos e impulsos. Opcional — o core loop funciona sem isso.",
  'common.new': 'Novo',
};
